module.exports = __webpack_public_path__ + "img/music-audio-pasue.41c75b0a.png";